export default {
  Confirm: '확인하기',
  Cancel: '취소',
  'The minimum time length is xxxs!': '최소 시간 길이는 {{num}}초입니다!',
  'The maximum time length is 50s!': '최대 시간 길이는 50s입니다!',
  'Online service, no download required': '온라인 서비스입니다.다운로드가 필요 없습니다.',
  'Add up to 20MB file': '파일 최대 20MB',
  'Support common formats': '유행형식 지원',
  'Best for general editing requirements': '일상적인 편집 수요를 해결합니다.',
  '0 second wait': '기다릴 필요 없이',
  'No size limits': '파일 크기 제한이 없이',
  'Support 1000+ formats': '1000여 가지 형식 지원',
  'Stable processing': '안정적 처리',
  'Get access to HitPaw Toolkit!': 'HitPaw Toolkit에 액세스하십시오!',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    '절단, 자르기 및 회전, 조정, 속도, 음악 추가, 스텁 모션 등 지원',
  'The easiest video editing software for beginners':
    '초보자를 위한 가장 쉬운 비디오 편집 소프트웨어',
  'Remove watermark from videos and images in simple clicks':
    '클릭 한번으로 비디오 및 이미지에서 워터마크 제거',
  'TRY IT FREE': '무료 이용',
  'BUY NOW': '지금 구입',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    '영상 해석 성공입니다! 파일이 100MB보다 커서 HitPaw Online에서 편집할 수 없습니다.',
  'download the video': '동영상을 다운로드',
  'and then use HitPaw Toolkit to proceed.': '한 다음 HitPaw Toolkit을 사용하여 계속 진행하십시오.',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    '비디오 조각을 최대 10개 잘라낼 수 있습니다. HitPaw Toolkit을 통해 더 많은 기능을 확인할 수 있습니다.',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    '파일 크기는 20MB보다 클 수 없습니다. HitPaw Toolkit을 통해 더 많은 기능을 확인할 수 있습니다.',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    '최소 시간 길이는 1초입니다! HitPaw Toolkit을 통해 더 많은 기능을 확인할 수 있습니다.',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    '최대 3개 비디오를 추가합니다. HitPaw Toolkit을 통해 더 많은 기능을 확인할 수 있습니다.',
  'This format is not supported currently.': '이 형식은 현재 지원되지 않습니다.',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    '이 형식은 현재 지원되지 않습니다. HitPaw Toolkit을 통해 더 많은 기능을 확인할 수 있습니다.',
  'Processing failed. Get HitPaw Toolkit for stable processing.': '비디오를 생성하지 못했습니다!',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': '로딩 실패!',
  'Are you sure you want to delete it?': '삭제하시겠습니까?',
  'Failed to extract the audio!': '오디오를 추출하지 못했습니다!',
  'Coming Soon': '곧 다가오기',
  'Learn more': '더 알아보기',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    '최대 2개의 파일을 추가합니다. HitPaw Toolkit을 통해 더 많은 기능을 확인할 수 있습니다.',
  Download: '다운로드',
  'Try Again': '다시 시도하십시오.',
  Failed: '실패하였습니다',
  'Get Started': '편집 시작하기',
  Start: '시작하기',
  End: '종료하기',
  Export: '내보내기',
  'Your audio is ready!': '오디오가 준비되었습니다!',
  'Download Audio': '오디오 다운로드',
  YES: '네.',
  'Export Failed': '내보내지 못했습니다.',
  'Error occurs, the file cannot be added': '오류가 발생했습니다. 파일을 추가할 수 없습니다.',
  'Support merging audio files at most': '최대 {{num}}개의 오디오 파일 병합 지원합니다.',
  'Are you sure you want to delete this task?': '이 작업을 삭제하시겠습니까?',
  Processing: '처리 중입니다',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    '파일을 다운로드하는 것을 잊지 마십시오. 24시간 후에는 파일이 완전히 삭제됩니다.',
  Uploading: '업로드 중',
  'Go Edit': '편집하기',
  'Generate Files Successfully!': '파일을 생성했습니다!',
  'Your order is being paid...': '주문 결제 중',
  'Not yet': '아직 아님',
  'Payment completed': '예',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'Your animated photo is ready!',
  'Download Without Watermark': 'Download Without Watermark',
  'Download As GIF': 'Download As GIF',
  'Download With Watermark': 'Download With Watermark',
  'Upload New Photo': 'Upload New Photo',
  ///////////
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 20MB. Download HitPaw Video Converter for more features.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 500MB. Download HitPaw Video Converter for more features.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'The uploaded image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
  'Download desktop version to batch process large files with no size limit': 'Download desktop version to batch process large files with no size limit',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convert Apple Music to MP3 with DRM removed (Windows version only)',
}
